import axios from "axios"
import config from '../../../config'

const path = `users`;

export const state = {
	token: null,
	name: null,
	status: "",
};

export const getters = {
	token: (state) => state.token,
	username: (state) => state.token ? state.token.username : null,
	role: (state) => state.token ? state.token.role : null,
	roleId: (state) => state.token ? state.token.roleId : null,
  isAuthenticated: state => !!state.token,
};

export const mutations = {
	token: function(state, tokenObj = null){
		// Ensure tokenObj is an object
		if(typeof tokenObj == 'string'){
			tokenObj = JSON.parse(tokenObj)
		}
		
		tokenObj
			? sessionStorage.setItem("token", JSON.stringify(tokenObj))
			: sessionStorage.removeItem("token")
			
    const base = axios.create({
      baseURL: config.backendHost || "http://localhost:8080/api",
      headers: {
        'Access-Control-Allow-Origin': '*',
        "Content-type": "application/json",
        "Authorization": (tokenObj ? `${tokenObj.token}` : 'null') 
      }
    });
    this._vm.$http = base
		state.token = tokenObj;
	},
	status: (state, status = "idle") => (state.status = status),
};

export const actions = {
	login({ commit }, data) {
		return this._vm.$http
			.post(`/${path}/login`, data)
			.then((response) => {
				const token = response.data ? response.data.token : null;
				const role = response.data ? response.data.role : null;
				const roleId = response.data ? response.data.roleId : null;
				if (token) {
					commit(`token`, {token, username : data.username, role, roleId});
				}
			})
			.catch((err) => {
				const status = err.response ? err.response.status : null;
        var errorMessage
        switch (status) {
					case 401:
						errorMessage = "Invalid Username or Password";
						break;
					case 500:
						errorMessage =
							"Internal Server Error. Please inform maintenance";
						break;
					default:
						errorMessage = "Something went wrong";
						break;
        }
        throw new Error(errorMessage)
			});
	},
	logout({ commit, getters }) {
		var username = getters.token ? getters.token.username : null 
		return this._vm.$http
			.post(`/${path}/logout`, {username})
			.then(() => {
				commit(`token`, null);
			})
			.catch((err) => {
        const status = err.response ? err.response.status : null;
        var errorMessage
        switch (status) {
					case 400:
						errorMessage = "User is already logged out";
						break;
					case 403: 
						commit(`token`)
						break;
					case 500:
						errorMessage =
							"Internal Server Error. Please inform maintenance";
						break;
					default:
						errorMessage = "Something went wrong";
						break;
        }
        throw new Error(errorMessage)
			});
	},
	checkAuth({ commit }){
		return new Promise((resolve) => {
			this._vm.$http
			.get(`/${path}/checkauth`)
			.then(()=> resolve(true))
			.catch(err =>{
				const status = err.response ? err.response.status : null;
				if(status === 403){
					commit(`token`)
					resolve(false)
				}else{
					resolve(true)
				}
			})
		}); 
	}, 
	generateExaminees(store, data) {
		return this._vm.$http.post(`/${path}/generateexaminees`, data);
	},

	// --- Generic Methods
	[`getAll`]() {
		return this._vm.$http.get(`/${path}`);
	},
	[`get`](store, { id }) {
		return this._vm.$http.get(`/${path}/${id}`);
	},
	[`create`](store, data) {
		return this._vm.$http.post(`/${path}`, data);
	},
	[`update`](store, { id, data }) {
		return this._vm.$http.put(`/${path}/${id}`, data);
	},
	[`delete`](store, { id }) {
		return this._vm.$http.delete(`/${path}/${id}`);
	},
	[`deleteAll`]() {
		return this._vm.$http.delete(`/${path}`);
	},
};
